import { createSelector } from 'reselect';

const resolveEntry = (entries, flattenedEntry, level) => {
  if (level === 0 || flattenedEntry === undefined) return flattenedEntry;

  const entry = Object.keys(flattenedEntry).reduce((expandingEntry, key) => {
    const field = expandingEntry[key];
    if (Array.isArray(field) && field.length && field[0].isEntry) {
      const arr = field
        .map(item => resolveEntry(entries, entries[item.entryId], level - 1))
        .filter(item => item !== undefined);
      return { ...expandingEntry, [key]: arr.length > 0 ? arr : undefined };
    } else if (typeof field === 'object' && field.entryId) {
      return { ...expandingEntry, [key]: resolveEntry(entries, entries[field.entryId], level - 1) };
    }
    return expandingEntry;
  }, flattenedEntry);

  return entry;
};

const getDataLevel = (state, props) => props.dataLevel;
const getEntries = state => state.entries;
const getNewsAndEvents = state => state.newsAndEvents;
const getInspirationArticles = state => state.inspirationArticles;
const getStyles = state => state.styles;
const getPages = state => state.pages;
const getUrl = (state, props) => {
  const { url } = props.match;
  const urlString = url[url.length - 1] === '/' ? url.slice(0, url.length - 1) : url;
  return urlString.replace(/\/salon-list\//, '/range/');
  // return url[url.length - 1] === '/' ? url.slice(0, url.length - 1) : url;
};

const getEntryId = createSelector([getPages, getUrl], (pages, url) => pages[url]);
const getFlatEntry = createSelector([getEntries, getEntryId], (entries, entryId) => entries[entryId]);

export const getPageData = createSelector(
  [getDataLevel, getEntries, getFlatEntry],
  (dataLevel, entries, flatEntry) => (flatEntry ? resolveEntry(entries, flatEntry, dataLevel) : flatEntry)
);

export const getArrayNewsAndEvents = createSelector(
  [getDataLevel, getEntries, getNewsAndEvents],
  (dataLevel, entries, newsAndEvents) => {
    const arr = [];
    newsAndEvents.forEach(item => arr.push(item));
    const result = arr.map(entryId => resolveEntry(entries, entries[entryId], dataLevel));
    return result;
  }
);

export const getArrayInspirationArticles = createSelector(
  [getDataLevel, getEntries, getInspirationArticles],
  (dataLevel, entries, inspirationArticles) => {
    const arr = [];
    inspirationArticles.forEach(item => arr.push(item));
    const result = arr.map(entryId => resolveEntry(entries, entries[entryId], dataLevel));
    return result;
  }
);

export const getArrayStyles = createSelector([getDataLevel, getEntries, getStyles], (dataLevel, entries, styles) => {
  const arr = [];
  styles.forEach(item => arr.push(item));
  const result = arr.map(entryId => resolveEntry(entries, entries[entryId], dataLevel));
  return result;
});



// WEBPACK FOOTER //
// ./src/redux/selectors/pages.js